package ca.derekellis.reroute.stops

sealed interface StopViewEvent

object Close : StopViewEvent
